import React from "react";

function TrainOfThoughtBox({ trainOfThought }) {
    console.log("TrainOfThoughtBox received:", trainOfThought);
    trainOfThought = trainOfThought || [];
  if (!Array.isArray(trainOfThought) || trainOfThought.length === 0) return null;
  return (
    <div style={{
      background: '#f5f8fa',

          
      border: '1px solid #e3eaf2',
      borderRadius: 8,
      padding: '12px 16px',
      marginTop: 10,
      marginBottom: 4,
      boxSizing: 'border-box',
    }}>
      <div style={{ fontWeight: 600, color: '#1a3556', fontSize: 15, marginBottom: 8 }}>Train of Thought</div>
      {trainOfThought.map((step, i) => (
        <div key={i} style={{ marginBottom: 10, paddingBottom: 8, borderBottom: i < trainOfThought.length - 1 ? '1px solid #e3eaf2' : 'none' }}>
          <div style={{ fontSize: 14, color: '#222', marginBottom: 2 }}><strong>Tool:</strong> {step.tool || 'N/A'}</div>
          <div style={{ fontSize: 14, color: '#222', marginBottom: 2 }}><strong>Query:</strong> {step.query || 'N/A'}</div>
          {step.intent && <div style={{ fontSize: 13, color: '#555', marginBottom: 2 }}><strong>Intent:</strong> {step.intent}</div>}
          {/* {step.summary && <div style={{ fontSize: 13, color: '#555', marginBottom: 2 }}><strong>Summary:</strong> {step.summary}</div>} */}
          <div style={{ fontSize: 14, color: '#222', marginBottom: 2 }}><strong>Answer:</strong> {step.answer || 'N/A'}</div>
        
        </div>
      ))}
    </div>
  );
}

export default TrainOfThoughtBox;
